export const SET_PROJECT_LAYERS_SUCCESS = 'layers/SET_PROJECT_LAYERS_SUCCESS';
export const SET_LAYER_FEATURES_SUCCESS = 'layers/SET_LAYER_FEATURES_SUCCESS';
export const SET_LAYER_HEATMAP_SUCCESS = 'layers/SET_LAYER_HEATMAP_SUCCESS';
export const SET_ENTIRE_TRACK = 'layers/SET_ENTIRE_TRACK';
export const SET_FULL_TRACK_TRACE = 'layers/SET_FULL_TRACK_TRACE';
export const SET_TRACK_INFO = 'layers/SET_TRACK_INFO';
export const SET_TRACK_OBSERVATIONS = 'SET_TRACK_OBSERVATIONS';
export const APPEND_TRACK_OBSERVATIONS = 'APPEND_TRACK_OBSERVATIONS';
export const SET_TRACK_OBSERVATION_COUNT = 'SET_TRACK_OBSERVATION_COUNT';
export const SET_TRACK_OBSERVATIONS_MEDIA = 'SET_TRACK_OBSERVATIONS_MEDIA';
export const CLEAR_ENTIRE_TRACK = 'layers/CLEAR_ENTIRE_TRACK';
export const SET_SELECTED_LAYERS = 'layers/SET_SELECTED_LAYERS';
export const SET_ALERT_FEATURES_SUCCESS = 'layers/SET_ALERT_FEATURES_SUCCESS';
export const CLEAR_COMMON_LAYER_FEATURES = 'layers/CLEAR_COMMON_LAYER_FEATURES';
export const SET_CAMTRAP_FOCUS = 'layers/SET_CAMTRAP_FOCUS';
export const CLEAR_CAMTRAP_FOCUS = 'layers/CLEAR_CAMTRAP_FOCUS';
export const SET_CAMTRAP_RESULTS = 'layers/SET_CAMTRAP_RESULTS';
export const SET_CAMTRAP_OBSERVATION_MEDIA =
  'layers/SET_CAMTRAP_OBSERVATION_MEDIA';
